import './ConfirmDeleteModal.css';
import { useTranslation } from 'react-i18next'; // Importa o hook de tradução

function ConfirmDeleteModal({ isOpen, onClose, onConfirm }) {
  const { t: tDatabase } = useTranslation('database');
  const { t: tCommon } = useTranslation('common');
  
  if (!isOpen) return null; 

  return (
    <div className="modal-overlay">
      <div className="modal-content-delete" data-testid="modal-delete">
        <img src="/imagens/trash-red.svg" alt={tDatabase('trashIcon')} className="modal-icon" />
        <p className="modal-message">{tDatabase('exclude_question')}</p>
        <div className="modal-actions">
          <button className="modal-button confirm" data-testid="modal-delete-yes" onClick={onConfirm}>{tCommon('yes')}</button>
          <button className="modal-button cancel" onClick={onClose}>{tCommon('no')}</button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDeleteModal;
